var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"broadcast-overrides"},[_c('dash-icon',{staticClass:"override-icon",attrs:{"icon":"override-orange"}}),_vm._v(" Overridden on individual Broadcasts. "),_c('router-link',{staticClass:"show-broadcasts-link",attrs:{"to":{
      name: 'station-details-broadcasts-view',
      params: { id: _vm.stationId }
    }}},[_vm._v(" Show broadcasts ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }